import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

import Cart, {
  CartItem,
  GiftItemType,
  GiftSectionType,
} from '../../types/cart';
import { serializeProduct } from '../home/getHomepage';

export const serializeGiftData = (data): GiftSectionType => {
  const giftItems = data?.gift_data?.map((item) => {
    const product = serializeProduct(item);
    const gift = item?.gift_details;
    const giftDetails = {
      isApplicable: gift?.is_applicable,
      title: gift?.title,
      subtitle: gift?.subtitle,
      inCart: gift?.in_cart,
      logo: gift?.logo,
      amountLeft: gift?.amount_left,
      cta: data?.cta,
      filter: data?.filter,
    };
    return {
      ...product,
      giftDetails,
    };
  });

  return {
    title: data?.title,
    giftItems,
  };
};
export const serializeCartWithCartData = (
  data: any,
  cartData: CartItem[],
  totalCartValue: number
) => {
  return {
    cartId: data?.id ?? 0,
    data: cartData,
    totalCartValue,
    isVirtual: data?.is_virtual ?? false,
    hasPriceChanged: data?.price_increased ?? false,
    newCartPrice: data?.new_cart_price ?? totalCartValue,
    oldCartPrice: data?.old_cart_price ?? totalCartValue,
    giftSection: data?.gift_section
      ? serializeGiftData(data?.gift_section)
      : null,
    stripData: data?.strip_data
      ? {
          icon: data.strip_data?.icon,
          text: data.strip_data?.text,
        }
      : null,
  };
};

export const serializeCart: (data: any) => Cart = (data) => {
  let totalCartValue = 0;
  const cartData: CartItem[] = data?.items?.map((item) => {
    const product = serializeProduct(item);
    const quantity = item?.qty;
    totalCartValue += product.discountedPrice * quantity;
    return {
      ...product,
      cartItemId: item?.item_id,
      mlUsed: item?.ml_used,
      mlSavings: item?.ml_savings,
      gst: item?.gst,
      skuCp: item?.sku_cp,
      quantity,
      pincode : item?.pincode,
      attributes: item?.attributes?.map((item) => ({
        title: item?.title,
        value: item?.value,
      })),
    };
  });
  return serializeCartWithCartData(data, cartData, totalCartValue);
};

const getCart = async (originPath?: string) => {
  let endPoint = `${apiConfig('magento')}/default/V2/carts/mine/customer`;
  if (originPath) {
    endPoint += `?origin_path=${originPath}`;
  }

  const { response, error }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
    enableErrorHandling: true,
  });
  if (response?.data) {
    return serializeCart(response.data);
  }
  //  else if (error) {
  //   toast.error(error?.message || 'Something went wrong');
  // }

  return null;
};

export default getCart;
